export const LEGAL_FEE = "Legal Fee";

export enum foreclosureStages {
  PROPERTY_SOLD_AT_FORECLOSURE = 'Property Sold at Foreclosure',
  REO = 'REO',
}